import { Link } from 'react-router-dom';

/**
 * フッター。全ページ共通（App.tsx の `shell` の中）。ヘッダーがフルネームだけになったので、
 * 略称・著作権表示・行き先はここに集める（doc/AUTH.md §13）。
 *
 * 置くのはサービス名（GenDan）・著作権表示・行き先だけ。
 * チーム名は著作権表示に入っているので、別立てにはしない（同じ名前を 2 度出さない）。
 * 行き先は **本文のあるページだけ**（doc/AUTH.md §13）。利用規約・プライバシーポリシーは本文を書いてから並べた。
 * 並びは読む順（規約 → ポリシー → ヘルプ → お問い合わせ）。まとめて右端に寄せる。
 * 問い合わせはメールアドレスを貼らずフォームで受ける（要ログイン。doc/AUTH.md §14）。
 */

/** 権利者。綴りを変えるならここだけ。 */
const HOLDER = 'x-type';
/** 公開した年。今年と同じなら 1 つだけ、違えば範囲で出す（年が変わっても直さなくていい形）。 */
const SINCE = 2026;

export function AppFooter() {
  const year = new Date().getFullYear();
  // 記号・年・権利者の順。`Copyright` と `©` は重ねない
  const copyright = `© ${year > SINCE ? `${SINCE}–${year}` : SINCE} ${HOLDER}`;
  return (
    <footer className="footer">
      <div className="footer__inner">
        <span className="footer__brand">GenDan</span>
        <small className="footer__copy">{copyright}</small>
        <nav className="footer__nav" aria-label="フッター">
          <Link className="footer__link" to="/terms">利用規約</Link>
          <Link className="footer__link" to="/privacy">プライバシーポリシー</Link>
          <Link className="footer__link" to="/help">ヘルプ</Link>
          <Link className="footer__link" to="/contact">お問い合わせ</Link>
        </nav>
      </div>
    </footer>
  );
}
